export default "__VITE_ASSET__DUf9ey28__"